import Http from './base-http'

class Site extends Http {
  login (credentials) {
    return this.client.post('login', credentials)
  }
}

const site = new Site({ modelUrlPrefix : 'site',apiVersion : '/' })

export default site
